module.exports = __webpack_public_path__ + "img/feat_hd.6f384a67.png";